import { useContext } from 'react'

import AuthContext from 'context/AuthContext'
import { GAME_CARD_OFFER_TYPE } from 'constants/index'
import { formatNumber } from 'utils/utils'

import useOfferClick from '../useOfferClick'
import ActiveOfferAvatar from './ActiveOfferAvatar'
import useOfferImpression, { offerTileData } from './useOfferImpression'
import { getCurrentTask } from './offerRewards'

/** The category the legacy page reported active offers under, kept so reports stay comparable. */
export const ACTIVE_OFFERS_CATEGORY = 'My Games'

const ContinueCard = ({ offer, index, observer, experiment, hasParsingEnabled }) => {
  const { ref, guid } = useOfferImpression(observer)
  const { handleClick, isDisabled } = useOfferClick({
    offer,
    index,
    type: GAME_CARD_OFFER_TYPE.ACTIVATED,
    offerTileViewGUID: guid,
    experiment,
  })
  const currentTask = getCurrentTask(offer.activatedOffer, { hasParsingEnabled })

  return (
    <button
      ref={ref}
      type="button"
      data-offer={offerTileData({
        offer,
        index,
        guid,
        category: ACTIVE_OFFERS_CATEGORY,
        categoryRowNumber: 0,
      })}
      className={`gamesListCard gamesRedesignContinueCard ${isDisabled ? 'disabled' : ''}`}
      onClick={handleClick}
      aria-label={`Continue ${offer.gameName}`}
    >
      <ActiveOfferAvatar offer={offer} />
      {currentTask?.piggyBanks > 0 && (
        <span className="gamesRedesignContinueReward">
          {formatNumber(currentTask.piggyBanks)}
          <img src="/images/pig.png" alt="" width={17} height={17} />
        </span>
      )}
    </button>
  )
}

/** Variant A: the offers in progress live inline, at the top of the page. */
const ContinueRow = ({ offers, observer, experiment }) => {
  const { user } = useContext(AuthContext)

  if (!offers?.length) {
    return null
  }

  return (
    <section className="gamesRedesignContinue">
      <header className="gamesRedesignContinueHeader">
        <h2 className="gamesRedesignContinueTitle">Continue</h2>
        <span className="gamesRedesignContinueCount">
          {offers.length} offer{offers.length === 1 ? '' : 's'}
        </span>
      </header>
      <div className="gamesRedesignContinueTrack">
        {offers.map((offer, index) => (
          <ContinueCard
            key={offer.id}
            offer={offer}
            index={index}
            observer={observer}
            experiment={experiment}
            hasParsingEnabled={user?.hasParsingEnabled}
          />
        ))}
      </div>
    </section>
  )
}

export default ContinueRow
